<template>
  <div>
    <v-content class="pt-0">
      <div class="table__overflow">
        <table class="datatable table">
          <thead>
            <tr>
              <th role="columnheader" scope="col" class="column text-xs-right">Tablet</th>
              <th role="columnheader" scope="col" class="column text-xs-right">Type</th>
              <th role="columnheader" scope="col" class="column text-xs-right">Group</th>
              <th role="columnheader" scope="col" class="column text-xs-right">IP</th>
              <th role="columnheader" scope="col" class="column text-xs-right">
                <v-text-field
                  color="primary"
                  label="Name"
                  @input="searchName"
                ></v-text-field>
              </th>
            </tr>
            <tr class="datatable__progress"><th colspan="100%" class="column"></th></tr>
          </thead>
          <tbody>
            <tr v-for="(tv, index) in tvs" :key="index">
              <td class="text-xs-right">{{tv.name}}</td>
              <td class="text-xs-right">Tablet</td>
              <td class="text-xs-right">{{tv.group.name}}</td>
              <td class="text-xs-right">{{tv.IP}}</td>
              <td class="text-xs-right">
                <v-btn fab dark small color="primary" @click.stop="editTvTrigger(tv, index)">
                  <v-icon dark>edit</v-icon>
                </v-btn>
                <v-btn fab dark small color="accent" @click.stop="deleteTvTrigger(tv, index)">
                  <v-icon dark>close</v-icon>
                </v-btn>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </v-content>
    <v-alert color="error" icon="warning" v-if="err" :value="err !== ''">
      {{err}}
    </v-alert>
    <v-dialog v-model="dialogEdit" max-width="500px">
      <edit-modal modalType="Tablet" v-if="dialogEdit" :tv="editTv" @close="closeEdit" @submit="submitEdit"></edit-modal>
    </v-dialog>
    <v-dialog v-model="dialogDelete" max-width="500px">
      <delete-modal modalType="Tablet" path="tv" :id="deleteId" v-if="dialogDelete" @close="closeDelete" @submit="submitDelete"></delete-modal>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import webHelper from '../../helpers/web';
import EditTv from '../modals/Tv';
import Delete from '../modals/Delete';

export default {
  data: () => ({
    editTv: null,
    editIndex: null,
    err: '',
    dialogEdit: false,
    dialogDelete: false,
  }),
  computed: mapGetters({
    tvs: 'tablet_tvs',
  }),
  methods: {
    editTvTrigger(tv, index) {
      this.editTv = tv;
      this.editIndex = index;
      this.dialogEdit = true;
    },
    deleteTvTrigger(tv, index) {
      this.deleteId = tv._id;
      this.deleteIndex = index;
      this.dialogDelete = true;
    },
    closeEdit() {
      this.editTv = null;
      this.editIndex = null;
      this.dialogEdit = false;
    },
    closeDelete() {
      this.deleteId = null;
      this.deleteIndex = null;
      this.dialogDelete = false;
    },
    submitEdit(event) {
      if (event.type === 0) {
        this.$store.dispatch('tablet_removeTv', this.editIndex);
      } else {
        this.$store.dispatch('tablet_editTv', { index: this.editIndex, tv: event });
      }
      this.closeEdit();
    },
    submitDelete() {
      this.$store.dispatch('tablet_removeTv', this.editIndex);
      this.closeDelete();
    },
    async searchName(event) {
      const url = event === '' ? 'tv?type=1' : `tv/search?type=1&query=${event}`;
      const res = await webHelper.get(this, url);
      if (res === null) {
        this.err = 'Failed to get the TVs.';
        return;
      }
      this.$store.dispatch('tablet_setTvs', res.tvs);
    },
  },
  components: {
    editModal: EditTv,
    deleteModal: Delete,
  },
  async created() {
    const res = await webHelper.get(this, 'tv?type=1');
    if (res === null) {
      this.err = 'Failed to get the Tablets.';
      return;
    }
    this.$store.dispatch('tablet_setTvs', res.tvs);
  },
};
</script>

<style lang="scss">
  .pt-0 main {
    padding: 0 !important;
  }

  thead {
    .input-group {
      .input-group__details {
        min-height: 16px;
      }
      label {
        font-size: 12px;
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/tvManager/Tablet.vue